import React from 'react';
import withStyles from '@mui/styles/withStyles';
import PropTypes from 'prop-types';
import { Button, Grid, Paper, TextField, Typography } from '@mui/material';

import SavingSpinner from '../ui/SavingSpinner';

import graphql from 'babel-plugin-relay/macro';
import { QueryRenderer } from 'react-relay';

import AbEnvironment from '../auth/AbEnvironment';

const abEnvironment = new AbEnvironment();

//Query fetches the reseller name and logo to approximate the email
const UserEmailFormResellerLogoQuery = graphql`
query UserEmailFormResellerLogoQuery($accountId: UUID!) {
  accountTByAccountId(accountId: $accountId) {
    accountName
    logo
  }
}
`;

const styleSheet = theme => ({
  root: {
    flexGrow: 1,
  },
  entryField: {
    paddingTop: 0,
  },
  button: {
    marginRight: '24px',
    paddingTop: '8px',
    paddingLeft: '24px',
    paddingRight: '24px',
    paddingBottom: '8px',
  },
  imageContainer: {
    height: 400,
    border: '1px solid black'
  },
  paper: {
    padding: theme.spacing(3),
  }
});

class UserEmailForm extends React.Component {
  state = {
    emailSubject: this.props.emailSubject,
    textBody: this.props.emailTextBody,
    showSpinner: false,
    showCancelSpinner: false,
  }
  
  componentDidMount() {
     if (abEnvironment.isSegmentActive()) {  window.analytics.track('Invite customer (user email form opened)'); }
  }

  disableEmailSend() {
    if (!this.state.emailSubject || !this.state.textBody) {
      return true;
    }
    if (this.state.textBody !== null) {
      return !this.props.auth.isEmailContentAllowed(this.state.textBody);
    } else {
      return false;
    }
  }

  showSpinner() {
    return this.state.showSpinner;
  }

  showCancelSpinner() {
    return this.state.showCancelSpinner;
  }

  handleSnackbarClose = (ev) => {
    this.setState({ saveStatus: null });
  }

  handleSend = () => {
    
    this.setState({ showSpinner: true });
    const { callPartnerApi } = this.props.auth;
 
    let aPjwt = abEnvironment.getPjwt();
 
    //for the emailBody, replace any new line with appropriate html
    const htmlBody = this.state.textBody.split("\n").join("<br/>");
    const newTextBody = this.state.textBody.split("\n").join("\\n");
 

    let payload = {
        operation: "resendUserInviteEmail",
        params: {
          pJwt: aPjwt,
          pAccountId: this.props.pAccountId,
          accountId: this.props.accountId,
          abUserId: this.props.userId,
          subject: this.state.emailSubject,
          htmlBody: htmlBody,
          textBody: newTextBody
        }
      }
      
      callPartnerApi('appbind/generic',
                     'POST',
                     payload
      )
      .then(response => {
        if (abEnvironment.isSegmentActive()) {  window.analytics.track('Invite customer (user email sent)'); }
        this.setState({ showSpinner: false });
        this.props.onClose();
      // console.log('Sent email');

      })
      .catch(error => {
         this.setState({ showSpinner: false }); 
        // console.log('Got error: ' + error);
      });
    
  }

  handleCancel = (userID, Auth0UserId) => {

    //this is passed as part of the confirm order flow.
    if (this.props.firstTimeInvite && this.props.firstTimeInvite === true) {


      this.setState({ showCancelSpinner: true });
      const { callPartnerApi } = this.props.auth;
      let aPjwt = abEnvironment.getPjwt();
  
  
      let payload = {
        operation: "deleteUser",
        params: {
          pJwt: aPjwt,
          userId: userID,
          auth0UserId: Auth0UserId
        }
      }
      
      callPartnerApi('appbind/generic',
                      'POST',
                      payload
      )
      .then(response => {
        this.props.onClose();
      })
      .catch(error => {
        //something odd happened
        this.props.onClose();
      });
  

    } else {
      this.props.onClose();
    }

  }

  render() {
    const classes = this.props.classes;

    let acctId = this.props.pAccountId;

    return (
      <QueryRenderer
        environment={abEnvironment.getEnvironment()}
        query={UserEmailFormResellerLogoQuery}
        variables={{accountId: acctId}}
        render={({error, props})=> {

          if (props) {
            let logoSrc = '/logos/appbind-logo-c-b.png';
            if (!error) {
              if (props.accountTByAccountId.logo) {
                logoSrc = props.accountTByAccountId.logo;
              }  
            }
        
            return (
              <Grid container spacing={3} direction="row">
                <Grid item xs={12}>
                  <Paper className={classes.paper}>
                    <Grid container spacing={3} direction="row">
                      <Grid item xs={12} >
                        <Typography align="center">
                          <img alt="AppBind or Reseller Logo" height="48px" src={logoSrc} />
                        </Typography>  
                      </Grid>
          
                      <Grid item xs={12} className={classes.entryField}>
                        <Typography variant="subtitle1">
                          To: {this.props.emailTo}
                        </Typography>
                      </Grid>
                      <Grid item xs={12} className={classes.entryField}>
                        <TextField style={{width: '100%'}}
                                      id="subject" label="Subject" 
                                      value={this.state.emailSubject}
                                      onChange={ (e) => this.setState({ emailSubject: e.target.value }) } />
                      </Grid>
        
                      <Grid item xs={12} className={classes.entryField}>
                        <TextField
                              multiline={true}
                              minRows={10}
                              maxRows={20} 
                              style={{width: '100%'}}
                              id="body" label="Body" 
                              value={this.state.textBody}
                              onChange={ (e) => this.setState({ textBody: e.target.value }) } />
                      </Grid>
                      <Grid item xs={12} align="center">
                        {!this.showSpinner() &&
                        <Button disabled={this.disableEmailSend()} color="primary"
                                variant="contained" onClick={() => {this.handleSend()}}  className={classes.button}>
                          Send Email
                        </Button>}
                        {this.showSpinner() &&
                        <Button color="primary" variant="contained"  className={classes.button} >
                          <SavingSpinner/>
                        </Button>}
                        {!this.showCancelSpinner() &&
                        <Button color="primary" variant="outlined"  
                          onClick={() => {this.handleCancel(this.props.userId, this.props.auth0Uid)}}  className={classes.button}>
                            Cancel
                        </Button>}
                        {this.showCancelSpinner() &&
                        <Button color="primary" variant="outlined"  
                            className={classes.button}>
                            <SavingSpinner/>
                        </Button>}
                      </Grid>
                    </Grid>
                  </Paper>
                </Grid>

                {/* 
                <Grid item xs={1} lg={3} >
                </Grid>

                <Grid item xs={12} >
                  <Typography variant="h5" align="center">
                    Your customer will receive an email
                  </Typography>
                </Grid>

                <Grid item xs={12} >
                  <img alt="Invite email" src={"/images/email-customer-invite.png"} className={classes.imageContainer} />
                </Grid>


                <Grid item xs={12} >
                  <Typography variant="h5" align="center" style={{marginTop: '24px'}}>
                    The button in the email takes them to their portal
                  </Typography>
                </Grid>

                <Grid item xs={12} >
                 <img alt="Customer portal" src={"/images/email-customer-portal.png"} className={classes.imageContainer} />
                </Grid>  
                */}      
            </Grid>
            );
          }
       }}
      />
    );
  }
}


UserEmailForm.propTypes = {
  classes: PropTypes.object.isRequired,
  auth: PropTypes.object.isRequired,
  emailTo: PropTypes.string.isRequired,
  emailSubject: PropTypes.string.isRequired,
  emailTextBody: PropTypes.string.isRequired,
  userId: PropTypes.string.isRequired,
  auth0Uid: PropTypes.string.isRequired,
  pAccountId: PropTypes.string.isRequired,
  accountId: PropTypes.string.isRequired,
  userArole: PropTypes.string.isRequired,
  onClose: PropTypes.func.isRequired
};

export default withStyles(styleSheet)(UserEmailForm)